<template>
  <Drawer
    v-model="exportingViaSlack"
    title="Send Results via Slack"
    placement="right"
    width="720"
    :closable="true"
    :mask-closable="false"
    class="drawer-class"
    @on-close="onDrawerClose"
  >
    <Form :model="formData">
      <FormItem label="Send to channel(s):">
        <Select
          v-model="formData.channels"
          multiple
          filterable
        >
          <Option
            v-for="channel in channels"
            :key="channel.id"
            :label="channel.name"
            :value="channel.id"
          />
        </Select>
      </FormItem>
      <FormItem label="Send to user(s):">
        <Select
          v-model="formData.users"
          multiple
          filterable
        >
          <Option
            v-for="user in users"
            :key="user.id"
            :label="user.realName"
            :value="user.id"
          />
        </Select>
      </FormItem>
      <FormItem label="Message">
        <Input v-model="formData.message" />
      </FormItem>
    </Form>
    <div class="drawer-footer">
      <Button
        type="primary"
        @click="sendMessage"
      >
        Send
      </Button>
    </div>
  </Drawer>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    queryId: Number,
    queryResults: Array,
    queryName: String,
    colTitleArr: Array,
    isExportingViaSlack: Boolean,
    context: String,
    users: Array,
    channels: Array
  },

  data () {
    return {
      exportingViaSlack: false,
      formData: {
        channels: [],
        users: [],
        message: ''
      }
    }
  },

  watch: {
    isExportingViaSlack (val) {
      this.exportingViaSlack = val
      if (this.exportingViaSlack) {
        this.formData.message = `${this.queryName} results`
      }
    }
  },

  methods: {
    /**
       * Emit isExportingViaSlack when user closes drawer
       */
    onDrawerClose () {
      this.formData.channels = []
      this.formData.users = []
      this.formData.message = ''
      this.exportingViaSlack = false
      this.$emit('isExportingViaSlack', this.exportingViaSlack)
    },

    /**
       * Exports the table contents as a csv via slack based on form contents
       */
    async sendMessage () {
      try {
        await axios({
          method: 'post',
          url: process.env.VUE_APP_API_URI + '/slack/csv',
          data: {
            userName: this.$auth.getUser().name,
            data: this.queryResults,
            queryId: this.queryId,
            channels: this.formData.channels,
            users: this.formData.users,
            message: this.formData.message
          }
        })
        this.$log('export_slack', this.query, { channels: this.formData.channels, users: this.formData.users, message: this.formData.message })
        this.onDrawerClose()
      } catch (error) {
        this.$Message.error(`Failed to export via slack: ${error}`)
      }
    }
  }
}
</script>
